// src/logging/index.ts
function addLogSink(sink) {
  return () => {
  };
}

// src/observability/index.ts
var rum = null;
var sentry = null;
async function initObservability(config) {
  if (config.rum) {
    try {
      const rumSpecifier = "aws-rum-web";
      const mod = await import(
        /* @vite-ignore */
        rumSpecifier
      );
      rum = new mod.AwsRum(
        config.rum.applicationId,
        config.rum.applicationVersion ?? "1.0.0",
        config.rum.region,
        {
          sessionSampleRate: 1,
          identityPoolId: config.rum.identityPoolId,
          endpoint: config.rum.endpoint ?? `https://dataplane.rum.${config.rum.region}.amazonaws.com`,
          telemetries: config.rum.telemetries ?? ["errors", "performance", "http"],
          allowCookies: config.rum.allowCookies ?? true,
          enableXRay: config.rum.enableXRay ?? false
        }
      );
    } catch {
    }
  }
  if (config.sentry) {
    try {
      const sentrySpecifier = "@sentry/browser";
      sentry = await import(
        /* @vite-ignore */
        sentrySpecifier
      );
      sentry.init({
        dsn: config.sentry.dsn,
        environment: config.sentry.environment,
        release: config.sentry.release,
        tracesSampleRate: config.sentry.tracesSampleRate ?? 0.1
      });
    } catch {
    }
  }
  if (config.forwardLogs) ;
}
function wireLogForwarding() {
  return addLogSink();
}
function captureException(error, context) {
  rum?.recordError(error);
  sentry?.captureException(error, context ? { extra: context } : void 0);
}
function captureMessage(message, level = "info") {
  sentry?.captureMessage(message, level);
}
function addBreadcrumb(category, message, data) {
  sentry?.addBreadcrumb({ category, message, data, level: "info" });
}
function recordApiResponse(info) {
  rum?.recordEvent("authe_api_request", info);
  if (info.status >= 500) addBreadcrumb("http", `HTTP ${info.status} ${info.url}`, info);
}
function _resetObservability() {
  rum = null;
  sentry = null;
}

export { _resetObservability, addBreadcrumb, captureException, captureMessage, initObservability, recordApiResponse, wireLogForwarding };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map